import { compareRows } from "@/mocks/homeSections";

export default function CompareSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.6fr] lg:gap-14">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <h2 className="text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              原始片段对照
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              同一份暗网流出物料常常有多个版本。左边保留原始片段，右边放整理后的线索，逐字核对哪里被改。
            </p>
            <div className="mt-6 overflow-hidden rounded-lg border border-background-200">
              <div className="h-44 w-full md:h-52">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20a%20raw%20torn%20document%20beside%20a%20neatly%20reorganized%20index%20card%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20film%20grain%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=1000&height=700&seq=hnb-compare-01&orientation=landscape"
                  alt="黑网爆料 原始片段与整理结果对照示意"
                  title="原始片段对照 暗网线索 暗网信息"
                  className="h-full w-full object-top"
                />
              </div>
            </div>
          </div>

          <div>
            <div className="hidden overflow-hidden rounded-t-lg border border-background-200 bg-background-50 sm:grid sm:grid-cols-2">
              <div className="border-r border-background-200 px-5 py-3 text-sm font-medium text-foreground-900">
                <span className="inline-flex items-center gap-2">
                  <i className="ri-file-warning-line text-primary-600"></i>
                  原始片段
                </span>
              </div>
              <div className="px-5 py-3 text-sm font-medium text-foreground-900">
                <span className="inline-flex items-center gap-2">
                  <i className="ri-shield-check-line text-secondary-600"></i>
                  整理结果
                </span>
              </div>
            </div>

            <div className="overflow-hidden rounded-lg border border-background-200 sm:rounded-t-none">
              {compareRows.map((row, index) => (
                <div
                  key={row.id}
                  className={`grid grid-cols-1 gap-4 px-5 py-5 sm:grid-cols-2 sm:gap-0 ${
                    index !== compareRows.length - 1 ? "border-b border-background-200" : ""
                  }`}
                >
                  <p className="text-sm leading-relaxed text-foreground-600 sm:pr-6">
                    <span className="mr-2 text-xs text-foreground-400 sm:hidden">原始片段</span>
                    {row.raw}
                  </p>
                  <div className="border-t border-background-200 pt-4 sm:border-l sm:border-t-0 sm:pl-6 sm:pt-0">
                    <p className="text-sm leading-relaxed text-foreground-800">
                      <span className="mr-2 text-xs text-foreground-400 sm:hidden">整理结果</span>
                      {row.clue}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}